import { Component } from '@angular/core';
import { ToastComponent } from '../toast.component';

@Component({
  selector: 'io-provetech-success-toast',
  templateUrl: './success-toast.component.html',
})
export class SuccessToastComponent extends ToastComponent {}
